"use client";
import "../Dashboard/Dashboard.css";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import Instance from "../../Utils/Axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { showToast } from "../../Utils/index";
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { BuyPrModal } from "../Modal/customModal";

import useDashboardStore from "../../store/dashboardStore";
import useUserStore from "../../store/userStore";

export default function Navbar({ name, hasCredits: propHasCredits }) {
  const [showResMenu, setShowResMenu] = useState(false);
  const { userProfile, fetchProfile } = useUserStore();
  const { activePackageCount, notificationData, notificationUnreadCount, fetchDashboardData } = useDashboardStore();
  const [hasCredits, setHasCredits] = useState(propHasCredits !== undefined ? propHasCredits : true);
  const [showBuyModal, setShowBuyModal] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const hideSubmitButton = location.pathname.includes("/customer/submit-pr") ||
    location.pathname.includes("/customer/pr-manager/edit");

  const handleLogout = () => {
    Instance.post("/user/logout", { /* tokenId: "" */ })
      .then((response) => {
        localStorage.removeItem("tokenId");
        // Remove tokenId cookie
        document.cookie = "tokenId=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        showToast("Logged Out Succesfully", "success", "success");
        setTimeout(() => {
          navigate("/");
        }, 2000);
      })
      .catch((error) => {
        console.error("Error logging out:", error);
      });
  };

  useEffect(() => {
    const fetchProfileData = () => {
      fetchProfile()
        .then((data) => {
          if (data && data.resCode == 400) {
            showToast("Unauthorized access, try login again", "error", "error")
            setTimeout(() => {
              navigate("/")
            }, 2000)
          }
        })
        .catch((error) => {
          const msg = error.response?.data?.resMessage || error.response?.data?.message;
          showToast(msg, "error", "error");
          // console.error("cannot fetch profile image", error);
        });
    };

    const checkCredits = () => {
      fetchDashboardData()
        .catch((err) => {
          const msg = err.response?.data?.resMessage || err.response?.data?.message;
          showToast(msg, "error", "error");
          // console.error("Failed to fetch dashboard data for credit check", err);
        });
    };
    fetchProfileData();
    if (propHasCredits === undefined) {
      checkCredits();
    }
  }, [fetchProfile, fetchDashboardData, propHasCredits]);

  useEffect(() => {
    if (propHasCredits !== undefined) {
      setHasCredits(propHasCredits);
    } else {
      setHasCredits(activePackageCount > 0);
    }
  }, [propHasCredits, activePackageCount]);


  const handleProtectedClick = (e) => {
    if (!hasCredits) {
      e.preventDefault();
      showToast("You don’t have an active credit or package!", "error", "error");
      setShowBuyModal(true);
    }
  };

  return (
    <>
      <nav className={`dash_navbar`}>
        {/* Toggle - visible only on mobile (left) */}
        <div
          className="d-lg-none nav-responsive ms-2"
          style={{ cursor: "pointer" }}
          onClick={() => {
            const event = new CustomEvent('toggle-sidebar');
            window.dispatchEvent(event);
          }}
        >
          <img
            src="/build/img/hamburger.svg"
            alt="hamburger"
            width={28}
            height={28}
          />
        </div>

        <div className={`title text-lg-start text-start flex-grow-1 ms-lg-0 ms-2`}>{name}</div>

        <div className={` nav_btn_container`}>
          <div className={` d-flex nav_btns align-items-center`}>
            {/* <div className={`search_btn d-none d-lg-flex`}>
              <input placeholder="search here" />
              <img
                className={""}
                src="/build/img/search.svg"
                alt="search"
                width={24}
                height={24}
              />
            </div> */}
            {/* <button className={`outline_btn`}>Buy Credits</button> */}
            <Link to="/customer/pricing" className={`outline_btn mb-0`} target="_blank">
              Buy Credits
            </Link>
            {!hideSubmitButton && (
              !hasCredits ? (
                <OverlayTrigger
                  placement="bottom"
                  overlay={<Tooltip>You need an active PR package or credits to submit a PR.</Tooltip>}
                >
                  <button
                    className={`fill_btn mb-0`}
                    onClick={handleProtectedClick}
                  >
                    Submit PR
                  </button>
                </OverlayTrigger>
              ) : (
                <Link to="/customer/submit-pr" className={`fill_btn mb-0`} target="_blank">
                  Submit PR
                </Link>
              )
            )}
          </div>

          <div className={`nav_profile `}>
            <div className="resposive_search d-none">
              <img
                className={""}
                src="/build/img/search.svg"
                alt="zex pr wire Logo"
                width={24}
                height={24}
              />
            </div>
            <div
              className="d-none d-lg-block position-relative me-4"
              style={{ cursor: 'pointer', overflow: 'visible', height: '24px', width: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
              onClick={() => navigate('/customer/notification')}
            >
              <img
                src="/build/img/notification.svg"
                alt="Notification"
                width={20}
                height={23}
              />
              {notificationUnreadCount > 0 && (
                <span
                  className="position-absolute badge rounded-pill bg-danger"
                  style={{
                    top: '-6px',
                    right: '-12px',
                    fontSize: '10px',
                    padding: '3px 6px',
                    border: '2px solid #fff',
                    zIndex: 10
                  }}
                >
                  {notificationUnreadCount}
                </span>
              )}
            </div>
            <div className="d-flex align-items-center">
              <div className="d-flex align-items-center">
                {/* <Link to="/customer/profile"> */}
                {/* </Link> */}
                <Dropdown className="profile_dropdown_mobile">
                  <Dropdown.Toggle
                    id="dropdown-basic"
                    className="p-0 border-0 bg-transparent d-flex align-items-center"
                    style={{ boxShadow: 'none' }}
                  >
                    <img
                      className={"nav_user_img"}
                      src={userProfile?.imageUrl || "/build/img/profile_img.svg"}
                      alt="icon"
                      width={50}
                      height={50}
                    />
                    <img
                      src="/build/img/downarrow.svg"
                      alt="arrow"
                      width={24}
                      height={24}
                      className="ms-1"
                    />
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item href="/customer/profile" target="_blank" className="custom_dropdown_item">
                      <img
                        className={"me-2"}
                        src="/build/img/setting.svg"
                        alt="setting"
                        width={14}
                        height={14}
                      />
                      Settings
                    </Dropdown.Item>
                    <Dropdown.Item onClick={handleLogout} className="custom_dropdown_item">
                      <img
                        className={"me-2"}
                        src="/build/img/log_out.svg"
                        alt="logout"
                        width={14}
                        height={14}
                      />
                      Logout
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
          </div>
          <div className={` ${showResMenu ? "responsive_menu" : "d-none"} `}>
            <div className=" res-profile d-flex justify-content-between align-items-center mb-2" style={{ background: '#231e5b', padding: '20px 16px' }}>
              <img
                className={"nav_user_img"}
                src={userProfile?.imageUrl || "/build/img/profile_img.svg"}
                alt="icon"
                width={50}
                height={50}
                style={{ border: '2px solid rgba(255,255,255,0.2)' }}
              />
              <img
                className={"pointer"}
                style={{ cursor: "pointer", filter: 'brightness(0) invert(1)' }}
                src="/build/img/close-menu.svg"
                alt="close"
                width={28}
                height={28}
                onClick={() => setShowResMenu(false)}
              />
            </div>
            <div className="responsive_menu_items" style={{ background: '#231e5b', height: '100%' }}>
              <Link to="/customer/pricing" onClick={() => setShowResMenu(false)}>
                <div className="menu_item p-3 border-bottom border-light border-opacity-10 text-white">Buy Credits </div>
              </Link>
              {!hideSubmitButton && (
                <Link to="/customer/submit-pr" onClick={() => setShowResMenu(false)}>
                  <div className="menu_item p-3 border-bottom border-light border-opacity-10 text-white">Submit PR</div>
                </Link>
              )}
              <Link to="/customer/profile" onClick={() => setShowResMenu(false)}>
                <div className="menu_item p-3 border-bottom border-light border-opacity-10 text-white">Settings</div>
              </Link>
              <div className="menu_item p-3 text-white" onClick={handleLogout} style={{ cursor: 'pointer' }}>
                Logout
              </div>
            </div>
          </div>
        </div>
      </nav>
      <BuyPrModal
        show={showBuyModal}
        onClose={() => setShowBuyModal(false)}
        onClick={() => {
          setShowBuyModal(false);
          navigate("/customer/pricing");
        }}
        title="You don’t have an active credit or package!"
        message="Buy a PR credit and start your PR campaign to reach millions of new users."
        primaryBtn="Buy PR Credit"
        icon="/build/img/Package.svg"
      />
    </>
  );
}
